import { identify, init } from '@dash0/sdk-web'

type InitDash0Params = {
  serviceName: string
  url: string
  authToken: string
  version?: string
  environment: string
}

export function initDash0({
  serviceName,
  url,
  authToken,
  version,
  environment,
}: InitDash0Params): void {
  if (environment !== 'production' && environment !== 'staging') {
    return
  }

  init({
    serviceName,
    endpoint: {
      url,
      authToken,
    },
    environment,
    additionalSignalAttributes: {
      version: version ?? 'unknown',
    },
    propagators: [
      {
        type: 'traceparent',
        match: [
          // Match staging and prod URLs for attachments, api, api-admin, pdf, reporting, subscriptions, and subscriptions-admin
          /^https?:\/\/(staging\.)?(attachments|api|api-admin|pdf|reporting|subscriptions|subscriptions-admin)\.siteline\.com\/.*/,
        ],
      },
    ],
    pageViewInstrumentation: {
      trackVirtualPageViews: true,
      includeParts: ['SEARCH', 'HASH'],
    },
  })
}

export function identifyDash0User(userId?: string, email?: string): void {
  if (!userId && !email) {
    return
  }

  identify(userId, {
    email,
  })
}
